export const sv = {
  // Common
  "common.back": "Tillbaka",
  "common.cancel": "Avbryt",
  "common.noItems": "Inga objekt",
  "common.loading": "Laddar...",
  
  // Header
  "nav.features": "Funktioner",
  "nav.howItWorks": "Hur det fungerar",
  "nav.pricing": "Priser",
  "nav.faq": "FAQ",
  "nav.testimonials": "Showcase",
  "nav.contact": "Kontakt",
  "button.getStarted": "Kom igång",
  "button.loading": "Laddar...",

  // Auth related
  "auth.signIn": "Logga in",
  "auth.redirecting": "Omdirigerar...",
  "auth.continueWithGoogle": "Fortsätt med Google",
  "auth.continueWithGithub": "Fortsätt med GitHub",
  "auth.or": "ELLER",
  "auth.consent.prefix": "Genom att fortsätta godkänner du våra",
  "auth.consent.terms": "Villkor",
  "auth.consent.and": "och",
  "auth.consent.privacy": "Integritetspolicy",

  // Site Title
  "site.title": "Communicate to Win",
  "site.title.first": "Communicate",
  "site.title.second": "to Win",
  "site.title.translated": "沟通制胜",

  // Hero Section
  "hero.title": "AI-driven Kommunikationsassistent",
  "hero.subtitle": "Förvandla dina konversationer med intelligenta, kontextmedvetna svar som hjälper dig kommunicera mer effektivt i alla situationer.",
  "hero.cta.primary": "Gratis provperiod",
  "hero.cta.secondary": "Se demo",
  "hero.cta.tryNow": "Kom igång gratis",
  "hero.cta.learnMore": "Läs mer",
  "hero.cta.getStarted": "Kom igång gratis",
  "hero.preview.primary": "Förbättra tonen",
  "hero.preview.secondary": "Översätt",
  "hero.preview.tone": "Vänlig",
  "hero.preview.target": "Kund",
  "hero.hook": "Gå med tusentals användare som förbättrar sin kommunikation varje dag.",
  "hero.headline": "AI-driven Kommunikationsassistent",
  "hero.subheadline": "Förvandla råa idéer till genomtänkta, kontextmedvetna svar på några sekunder.",
  
  // Stats
  "stats.users": "Användare",
  "stats.replies": "Svar",
  "stats.languages": "Språk",

  // Main Title
  "main.title": "Förvandla varje svar till en möjlighet",

  // Footer Section
  "footer.company": "Företag",
  "footer.product": "Produkt",
  "footer.support": "Support",
  "footer.legal": "Juridiskt",
  "footer.contactSupport": "Kontakta support",
  "footer.helpCenter": "Hjälpcenter",
  "footer.apiDocs": "API-dokumentation",
  "footer.statusPage": "Statussida",
  "footer.privacyPolicy": "Integritetspolicy",
  "footer.termsOfService": "Användarvillkor",
  "footer.cookiePolicy": "Cookie-policy",
  "footer.refundPolicy": "Återbetalningspolicy",
  "footer.copyright": "© 2025 DOUBLEWIND LTD. All rights reserved.",
  "footer.supportLabel": "Support",

  // Features Section
  "features.badge": "Kraftfulla funktioner",
  "features.title": "allt du behöver för bättre kommunikation",
  "features.subtitle": "Omfattande verktyg designade för att göra varje konversation mer effektiv och professionell.",
  "features.scenario.title": "Scenariomallar",
  "features.scenario.description": "Förbyggda mallar för arbetsplats, personlig, akademisk och professionell kommunikation.",
  "features.custom.title": "Anpassade inmatningar",
  "features.custom.description": "Klistra in vilket meddelande eller innehåll som helst och få kontextuellt lämpliga svar.",
  "features.instant.title": "Minska svarstid med 90%",
  "features.instant.description": "Få AI-skapade svar på några sekunder. Ingen väntan, bara resultat.",
  "features.copy.title": "Ett-klicks kopiering och delning",
  "features.copy.description": "Kopiera svar direkt eller dela dem direkt från plattformen.",

  // How It Works Section
  "howItWorks.badge": "Hur det fungerar",
  "howItWorks.title": "Tre enkla steg till bättre kommunikation",
  "howItWorks.subtitle": "Vår strömlinjeformade process gör det enkelt att generera professionella svar för alla situationer.",
  "howItWorks.step1.title": "Välj scenario",
  "howItWorks.step1.description": "Välj det kommunikationsscenario som bäst passar dina behov.",
  "howItWorks.step2.title": "Klistra in innehåll",
  "howItWorks.step2.description": "Lägg till meddelandet eller innehållet du behöver svara på.",
  "howItWorks.step3.title": "Få AI-svar",
  "howItWorks.step3.description": "Ta emot ett professionellt, kontextuellt svar på sekunder.",

  // Pricing Section
  "pricing.title": "Priser",
  "pricing.subtitle": "Välj den plan som passar dina kommunikationsbehov",
  "pricing.plan.free": "Free",
  "pricing.plan.pro": "Pro",
  "pricing.plan.business": "Enterprise",
  "pricing.free.price": "$0",
  "pricing.pro.price": "$9.99",
  "pricing.business.price": "$29.99",
  "pricing.period": "/månad",
  "pricing.free.description": "Perfekt för att prova vår tjänst",
  "pricing.pro.description": "Idealisk för proffs och frekventa användare",
  "pricing.business.description": "För team och organisationer",
  "pricing.popular": "Mest populär",
  "pricing.free.feature1": "10 svar per månad",
  "pricing.free.feature2": "Grundscenario",
  "pricing.free.feature3": "Definiera och använd mallar",
  "pricing.free.feature4": "Historiska svarsregister",
  "pricing.pro.feature1": "200 svar per månad",
  "pricing.pro.feature2": "Grund+anpassat scenario",
  "pricing.pro.feature3": "Definiera och använd mallar",
  "pricing.pro.feature4": "Historiska svarsregister",
  "pricing.pro.feature5": "Avancerad anpassning",
  "pricing.business.feature1": "Obegränsade svar",
  "pricing.business.feature2": "Teamsamarbete",
  "pricing.business.feature3": "Grund+anpassat scenario",
  "pricing.business.feature4": "Definiera och använd mallar",
  "pricing.business.feature5": "Historiska svarsregister",
  "pricing.business.feature6": "Avancerad anpassning",
  "pricing.cta.trial": "Starta gratis provperiod",
  "pricing.cta.subscribe": "Prenumerera",
  "pricing.cta.contact": "Kontakta försäljning",
  "pricing.cta.current": "Nuvarande plan",
  "pricing.currentPlan": "Nuvarande plan:",
  "pricing.endDate": "Slutdatum för nuvarande plan:",
  "pricing.autoRenewalDate": "Automatisk förnyelsedatum för nuvarande plan:",
  "pricing.answersLeft": "Kvarvarande svar:",
  "pricing.planName.free": "Free Plan",
  "pricing.planName.proMonthly": "Pro Plan-Månadsvis",
  "pricing.planName.proYearly": "Pro Plan-Årligen",
  "pricing.planName.maxMonthly": "Enterprise Plan-Månadsvis",
  "pricing.planName.maxYearly": "Enterprise Plan-Årligen",
  "pricing.autoRenews": "Din svarsräkning förnyas automatiskt den:",
  "pricing.needMore": "Behöver fler svar?",
  "pricing.upgradeBelow": "Uppgradera din plan nedan",
  "pricing.doNotRollOver": "Oanvända svar överförs inte",
  "pricing.willCancelOn": "Kommer att avbrytas den:",
  "pricing.downgradeScheduled": "Nedgradering schemalagd. Kommer att byta till",
  "pricing.on": "den:",
  "pricing.upgradeImmediateTitle": "Plan uppgraderad",
  "pricing.upgradeImmediateDesc": "Din nya plan är nu aktiv.",
  "pricing.downgradeScheduledTitle": "Nedgradering schemalagd",
  "pricing.downgradeScheduledDesc": "Din plan kommer att ändras vid nästa förnyelse.",
  "pricing.cancelScheduledTitle": "Avbrytning schemalagd",
  "pricing.cancelScheduledDesc": "Din plan kommer att avslutas vid periodens slut.",
  "pricing.cancelResumedTitle": "Avbrytning borttagen",
  "pricing.cancelResumedDesc": "Din prenumeration kommer att fortsätta förnyas.",
  "pricing.cancelPendingDowngrade": "Avbryt",
  "pricing.pendingDowngradeCanceledTitle": "Väntande nedgradering avbruten",
  "pricing.pendingDowngradeCanceledDesc": "Din plan kommer att förbli oförändrad.",
  "pricing.pendingDowngradeCancelFailedTitle": "Avbrytning misslyckades",
  "pricing.pendingDowngradeCancelFailedDesc": "Kunde inte avbryta väntande nedgradering. Försök igen.",
  "pricing.cancelPendingDowngradeProcessing": "Bearbetar...",
  "pricing.scheduled": "Schemalagd",
  "pricing.processing": "Bearbetar...",
  "pricing.getMoreReplies": "Få fler svar",
  "pricing.oneTimeTitle": "Få fler svar till ditt konto",
  "pricing.oneTimeAmountLabel": "Belopp (USD)",
  "pricing.repliesUnit": "Svar",
  "pricing.oneTimeNotice": "Antalet svar du köper är giltigt under den aktuella månads-cykeln. En aktiv betald prenumeration krävs för att använda dem och oanvända svar överförs inte.",
  "pricing.cancel": "Avbryt",
  "pricing.proceed": "Fortsätt",
  "pricing.confirmUpgradeTitle": "Bekräfta uppgradering",
  "pricing.confirmDowngradeTitle": "Bekräfta nedgradering",
  "pricing.confirmUpgradeDesc": "Du är på väg att uppgradera din plan. Ändringen träder i kraft omedelbart och proportionella avgifter (eller krediter) kan tillämpas.",
  "pricing.confirmDowngradeDesc": "Du är på väg att schemalägga en nedgradering. Dina nuvarande funktioner kommer att vara kvar till slutet av den aktuella faktureringsperioden.",
  "pricing.downgradeEffectNote": "Nedgradering återbetalar inte den aktuella cykeln.",
  "pricing.downgradeApplyNextCycle": "Den nya planen startar automatiskt vid förnyelse.",
  "pricing.confirmCancel": "Tillbaka",
  "pricing.confirmProceedUpgrade": "Uppgradera nu",
  "pricing.confirmProceedDowngrade": "Schemalägg nedgradering",

  // FAQ Section
  "faq.title": "Vanliga frågor",
  "faq.subtitle": "Allt du behöver veta om communicate2win",
  "faq.q1": "Vilka kommunikationsscenarier stöds?",
  "faq.a1": "Vi stödjer arbetsplatskommunikation, personliga relationer, akademisk korrespondens, kundservice, försäljningsutreach och många andra scenarier. Vår AI anpassar sig till den kontext och ton som krävs för varje situation.",
  "faq.q2": "Hur snabbt genereras svaren?",
  "faq.a2": "Vår AI genererar svar på några sekunder. Vi prioriterar hastighet utan att kompromissa med kvaliteten, vilket säkerställer att du får professionella svar omedelbart.",
  "faq.q3": "Kan jag avbryta min prenumeration när som helst?",
  "faq.a3": "Ja, du kan avbryta din prenumeration när som helst. Det finns inga långsiktiga åtaganden, och du kan nedgradera eller uppgradera din plan efter behov.",
  "faq.q4": "Är mina data säkra och privata?",
  "faq.a4": "Ja, vi implementerar omfattande säkerhetsåtgärder inklusive kryptering, åtkomstkontroller och regelbundna säkerhetsrevisioner. Ditt inmatningsinnehåll och genererade svar lagras som en del av din användarhistorik för att möjliggöra funktioner som svarsgranskning och mallskapande. Du kan ta bort dina historikdata när som helst genom dina kontoinställningar.",
  "faq.q5": "Vad händer om mina Replies tar slut?",
  "faq.a5": "Free-användare måste vänta till nästa månads-cykel för förnyelse. Efter uppgradering till Pro kan du köpa extra engångs-Replies; dessa extra gäller bara för den aktuella månads-cykeln. Enterprise-användare har obegränsade Replies.",
  "faq.q6": "Vilka språk stöds?",
  "faq.a6": "För närvarande stödjer vi engelska med planer på att expandera till spanska, franska, tyska och andra större språk. AI:n kan hantera flerspråkig kommunikation effektivt.",

  // Testimonials Section
  "testimonials.title": "Kommunikations-showcase",
  "testimonials.subtitle": "Offentliga meddelanden, e-post och AI-polerade svar för att inspirera dina egna",
  "testimonials.sarah.name": "Sarah Johnson",
  "testimonials.sarah.title": "Marknadschef",
  "testimonials.sarah.quote": "communicate2win har förvandlat hur jag hanterar kundkommunikation. Svaren är professionella och sparar mig timmar varje vecka.",
  "testimonials.michael.name": "Michael Chen",
  "testimonials.michael.title": "Försäljningschef",
  "testimonials.michael.quote": "Arbetsplatsscenariomallarna är otroligt exakta. Min svarsfrekvens har förbättrats med 40% sedan jag började använda detta verktyg.",
  "testimonials.emily.name": "Emily Rodriguez",
  "testimonials.emily.title": "Kundframgångsledare",
  "testimonials.emily.quote": "Perfekt för att hantera svåra kundsituationer. AI:n förstår kontext och ton perfekt.",
  "testimonials.more": "Klicka på galleriet för att utforska hela showcase",

  // Interface Elements
  "interface.generating": "Genererar svar...",
  "interface.generate": "Generera AI-svar",
  "interface.processing": "Bearbetar...",
  "interface.advancedOptions": "Avancerade alternativ",
  "interface.clearInput": "Rensa inmatning",
  "interface.clearDescription": "Rensa beskrivning",
  // Marquee / Logos
  "marquee.trusted": "Partners / Support",
  "marquee.aria": "Varumärkeslogotyper",

  // History and Showcase
  "history.shareToShowcase": "Dela till showcase",
  "history.showcased": "I showcase",
  "history.shareConfirm": "Dela detta inlägg till showcase? Denna åtgärd kan inte ångras såvida du inte tar bort inlägget.",
  "history.sharedBy": "Delat av:",
  "interface.copy": "Kopiera",
  "interface.share": "Dela",
  "interface.shareResponse": "Dela svar",
  "interface.shareNative": "Dela via system",
  "interface.shareEmail": "E-post",
  "interface.copyShareText": "Kopiera med länk",
  "interface.shareTextCopied": "Svar och länk kopierad till urklipp.",
  "interface.ready": "Redo att generera",
  "interface.enterMessage": "Ange ditt meddelandeinnehåll och välj ett scenario för att komma igång med AI-drivna svar.",
  "interface.fast": "Snabb",
  "interface.accurate": "Exakt",
  "interface.professional": "Professionell",
  "interface.translation": "Översättning",
  "interface.responseDescription": "Här är ett genomtänkt och professionellt svar anpassat till kontexten:",
  "interface.multipleOptions": "Flera svarsalternativ:",
  "interface.option": "Alternativ",
  "interface.noContent": "Inget innehåll tillgängligt",

  // Placeholders
  "placeholder.message": "Klistra in meddelandet du svarar på, e-postinnehåll eller text du fått...",

  // Dropdowns
  "dropdown.useTemplates": "Använd mallar",
  "dropdown.scenario": "Inget scenario",
  "dropdown.target": "Inget mål",
  "dropdown.tone": "Ingen ton",

  // Scenario Options
  "scenario.email": "E-post",
  "scenario.message": "Meddelande",
  "scenario.workplace": "Arbetsplats",
  "scenario.school": "Skola",
  "scenario.home": "Hem",
  "scenario.business": "Affärer",
  "scenario.academic": "Akademisk",
  "scenario.social": "Social",
  "scenario.formal": "Formell",
  "scenario.casual": "Avslappnad",
  "scenario.professional": "Professionell",
  "scenario.personal": "Personlig",
  "scenario.customerService": "Kundservice",
  "scenario.interview": "Intervju",
  "scenario.presentation": "Presentation",

  // Target Options
  "target.lover": "Älskare",
  "target.friend": "Vän",
  "target.boss": "Chef",
  "target.colleague": "Kollega",
  "target.classmate": "Klasskamrat",
  "target.parents": "Föräldrar",
  "target.child": "Barn",
  "target.teacher": "Lärare",
  "target.student": "Student",
  "target.client": "Klient",
  "target.customer": "Kund",
  "target.stranger": "Främling",
  "target.family": "Familj",
  "target.sibling": "Syskon",
  "target.neighbor": "Granne",
  "target.mentor": "Mentor",
  "target.supplier": "Leverantör",
  "target.serviceProvider": "Tjänsteleverantör",
  "target.partner": "Partner",
  "target.subordinate": "Underordnad",

  // Tone Options
  "tone.humorous": "Humoristisk",
  "tone.serious": "Seriös",
  "tone.happy": "Glad",
  "tone.angry": "Arg",
  "tone.mischievous": "Busig",
  "tone.polite": "Artig",
  "tone.casual": "Avslappnad",
  "tone.formal": "Formell",
  "tone.friendly": "Vänlig",
  "tone.confident": "Självsäker",
  "tone.apologetic": "Ursäktande",
  "tone.enthusiastic": "Entusiastisk",

  // Status Messages
  "status.copied": "Kopierat!",
  "status.copyDescription": "Svar kopierat till urklipp.",
  "status.copyWithTranslationDescription": "Svar och översättning kopierat till urklipp.",
  "status.success": "Svar genererat framgångsrikt. ",
  "status.successWithTranslation": "Svar genererat med översättning.",
  "status.successWithoutTranslation": "Svar genererat framgångsrikt.",
  "status.error": "Generering misslyckades",
  "status.errorDescription": "Kunde inte generera svar. Försök igen.",
  "status.enterContent": "Ange innehåll",
  "status.enterContentDescription": "Lägg till meddelandet du vill svara på.",

  // Pro/Max subscriber restrictions
  "restriction.descriptionOptional": "Beskrivning (valfritt)",
  "restriction.descriptionLabel": "Beskrivning (Endast för Pro / Enterprise-prenumeranter)",
  "restriction.proMaxOnly": "* Endast för Pro / Enterprise-prenumeranter",
  "restriction.desPrompt": "Ange kontext, bakgrundsinformation eller specifika krav som kan hjälpa till att generera bättre svar...",

  // Demo functionality for non-logged-in users
  "demo.title": "Välj ett meddelande att svara på",
  "demo.option1": "Försäljningsöppnare (kall kontakt)",
  "demo.option2": "Hantera en \"ert pris är högt\" undersökning",
  "demo.option3": "Intervju självpresentation (30-sekunders version)",
  "demo.option4": "E-postsvar",
  "demo.option5": "Uppföljning för en \"läst-men-inget-svar\" prospekt",
  "demo.option6": "Elevator pitch (30 sekunder)",
  "demo.runDemo": "Kör Demo",
  "demo.inputContent": "Inmatningsinnehåll:",
  "demo.scenario": "Scenario:",
  "demo.target": "Mål:",
  "demo.tone": "Ton:",
  "demo.description": "Beskrivning:",

  // Showcase Page
  "showcase.title": "Kommunikations-showcase",
  "showcase.subtitle": "Upptäck AI-driven inspirerande kommunikation som delats av vår community",
  "showcase.userPrefix": "Offentlig kommunikation av",
  "showcase.backAll": "Tillbaka till alla showcase",
  "showcase.sortBy": "Sortera efter:",
  "showcase.sort.newest": "Nyast först",
  "showcase.sort.oldest": "Äldst först",
  "showcase.sort.scenario": "Efter scenario",
  "showcase.sort.target": "Efter mål",
  "showcase.sort.tone": "Efter ton",
  "showcase.filter.scenario": "Scenario:",
  "showcase.filter.target": "Mål:",
  "showcase.filter.tone": "Ton:",
  "showcase.filter.all": "Alla",
  "showcase.loading": "Laddar showcase...",
  "showcase.loadingUser": "Laddar användarkommunikation...",
  "showcase.loadingMore": "Laddar mer...",
  "showcase.none.userTitle": "Ingen offentlig kommunikation ännu",
  "showcase.none.globalTitle": "Inga showcase-objekt ännu",
  "showcase.none.userDesc": "Denna användare har inte delat någon kommunikation i showcase ännu.",
  "showcase.none.globalDesc": "Bli den första att dela din AI-kommunikation i showcase!",
  "showcase.messageDetails": "Meddelandedetaljer",
  "showcase.field.date": "Datum",
  "showcase.field.scenario": "Scenario",
  "showcase.field.target": "Mål",
  "showcase.field.tone": "Ton",
  "showcase.originalMessage": "Originalmeddelande",
  "showcase.description": "Beskrivning",
  "showcase.aiResponse": "AI-svar",

  // Templates
  "templates.saveAsTemplate": "Spara som mall",
  "templates.saved": "Mall sparad",
  "templates.saveSuccess": "Mall sparad framgångsrikt",
  "templates.title": "Mina mallar",
  "templates.new": "Ny mall",
  "templates.loading": "Laddar...",
  "templates.none": "Inga mallar hittades",
  "templates.name": "Namn",
  "templates.scenario": "Scenario",
  "templates.target": "Mål",
  "templates.tone": "Ton",
  "templates.description": "Beskrivning",
  "templates.save": "Spara",
  "templates.saving": "Sparar...",
  "templates.delete": "Ta bort mall",
  "templates.deleteConfirm": "Ta bort denna mall?",
  "templates.deleteFailed": "Misslyckades med att ta bort mall",
  "templates.nameRequired": "* Ange mallnamn",
  "templates.deleteSuccess": "Mall borttagen framgångsrikt",

  // History Modal additions
  "history.messageDetails": "Meddelandedetaljer",
  "history.messageDetailsDesc": "Visa och hantera meddelandedetaljer, inklusive originalinmatning och AI-genererat svar.",
  "history.field.date": "Datum",
  "history.field.scenario": "Scenario",
  "history.field.target": "Mål",
  "history.field.tone": "Ton",
  "history.originalMessage": "Originalmeddelande",
  "history.aiResponse": "AI-svar",
  "history.description": "Beskrivning",
  "history.listTitle": "Meddelandehistorik",
  "history.listDesc": "Bläddra, filtrera och hantera din konversationshistorik. Klicka på ett meddelande för att visa detaljer.",
  "history.sortBy": "Sortera efter:",
  "history.sort.newest": "Nyast först",
  "history.sort.oldest": "Äldst först",
  "history.sort.scenario": "Efter scenario",
  "history.sort.target": "Efter mål",
  "history.sort.tone": "Efter ton",
  "history.filter.scenario": "Scenario:",
  "history.filter.target": "Mål:",
  "history.filter.tone": "Ton:",
  "history.filter.all": "Alla",
  "history.loading": "Laddar historik...",
  "history.loadingMore": "Laddar mer...",
  "history.none": "Inga meddelanden hittades",
  "history.showing": "Visar {current} av {total} meddelanden",
  "history.allLoaded": "Alla meddelanden laddade",
  "history.scrollMore": "Scrolla ner för mer",
  "history.loadMoreButton": "Ladda mer",
  "history.deleteMessage": "Ta bort meddelande",
  "history.deleting": "Tar bort...",
  "history.deleteSuccess": "Meddelandepost borttagen framgångsrikt",
  "history.deleteFailed": "Misslyckades med att ta bort meddelandepost, försök igen",
  "history.confirmDeleteTitle": "Bekräfta borttagning",
  "history.confirmDeleteSubtitle": "Denna åtgärd kan inte ångras",
  "history.confirmDeleteDesc": "Är du säker på att du vill ta bort denna meddelandepost?",
  "history.confirmDeleteAction": "Bekräfta borttagning",
  "history.shareTitle": "Dela till showcase",
  "history.shareSubtitle": "Gör detta meddelande offentligt",
  "history.sharing": "Delar...",
  "history.confirmShareAction": "Bekräfta delning",
  "history.shareSuccess": "Meddelande delat framgångsrikt till showcase",
  "history.shareFailed": "Misslyckades med att dela till showcase, försök igen",
  "templates.saveFailed": "Misslyckades med att spara mall",

  // User Menu
  "userMenu.myAccount": "Mitt Konto",
  "userMenu.history": "Historik",
  "userMenu.templates": "Mallar",
  "userMenu.signOut": "Logga ut",
  
  // Hero Showcase / Demo Tabs / Previews
  "hero.preview.aiReply": "AI-svar förhandsgranskning",
  "hero.preview.scenarioLabel": "Scenario",
  // Demo short tab titles (mapped from demo option ids)
  "demo.shortTitle.salesOpener": "Försäljningsöppnare",
  "demo.shortTitle.priceObjection": "Prisinvändning",
  "demo.shortTitle.interviewIntro": "Intervjuintro",
  "demo.shortTitle.emailReply": "E-postsvar",
  "demo.shortTitle.followUp": "Uppföljning",
  "demo.shortTitle.elevatorPitch": "Elevator pitch",
  // Demo path / response overlay
  "demoTabs.pathPrefix": "demo",
  "demoTabs.response": "svar",
  "demoTabs.inputPrompt": "INPUT PROMPT",
  "demoTabs.context": "KONTEXT",
  "demoTabs.description": "Beskrivning",
  "demoTabs.generate": "Generera",
  "demoTabs.aiOutput": "AI OUTPUT",
  "demoTabs.sample": "exempel",
  "demoTabs.streaming": "Strömmar tokens...",
  "preview.section.scenarioTemplates.title": "Scenarier & Mallar",
  "preview.section.scenarioTemplates.subtitle": "Välj snabbt ett scenario eller tillämpa en sparad mall. Mallar förifyller beskrivning/mål/ton så att du direkt kan gå in i högkvalitativ generering.",
  "preview.section.customInputs.title": "Anpassade inmatningar",
  "preview.section.customInputs.subtitle": "Kärninmatning + valfri beskrivning + avancerade Scenario/Mål/Ton-väljare. Kombinera fritt för kontextmedvetna resultat.",
  "preview.section.cutReplyTime.title": "Minska svarstiden med 90%",
  "preview.section.cutReplyTime.subtitle": "Jämför manuell utkastning vs AI-assistans. Parallella alternativ + inbyggda översättnings- eller revideringsloopar.",
  "preview.section.copyShare.title": "Ett-klicks kopiering och delning",
  "preview.section.copyShare.subtitle": "Flera alternativ ordnade med enhetliga toppåtgärder: kopiera alla / dela / kopiera per alternativ. Översättning bifogas automatiskt.",
  "preview.templates.my": "Mina mallar",
  "preview.templates.new": "Ny",
  "preview.manualFlow": "Manuellt flöde",
  "preview.aiAssisted": "AI-assisterad",
  // Manual flow bullet steps
  "preview.manualFlow.step1": "Planera struktur & ton",
  "preview.manualFlow.step2": "Utkast introduktion / radera & skriv om",
  "preview.manualFlow.step3": "Justera artighet & grammatik",
  "preview.manualFlow.step4": "Sök ordförråd + verifiera översättning",
  "preview.manualFlow.step5": "Klistra in i målapp",
  "preview.copyAll": "Kopiera alla",
  "preview.share": "Dela",
  "preview.enPlusTranslation": "EN + Översättning",
  "preview.translationAppendNote": "(*) Översättning bifogas automatiskt vid kopiering av alla.",
  "preview.field.scenario": "Scenario",
  "preview.field.target": "Mål",
  "preview.field.tone": "Ton",
  "preview.auto": "Automatisk",
  "preview.step.pasteOrTemplate": "Klistra in begäran eller välj mall",
  "preview.step.optionalDescription": "(Valfritt) lägg till beskrivning/scenario",
  "preview.step.pickOption": "Välj ett av de genererade alternativen",
  "preview.step.copyShareTranslate": "Ett-klicks kopiera/dela/översätt",
  "preview.time.manual": "5–8 minuter",
  "preview.time.ai": "30–40 sekunder"
};